import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  Admin → Kapcsolatok (backend/kapcsolat.js).
 *
 *  Az ADATGAZDA oldala: kapcsolati kódot ad ki (pl. a könyvelőnek a béradatokhoz, a jelenléthez, a
 *  számlákhoz), látja, ki és mikor kér adatot, és bármikor megszüntetheti a kapcsolatot. Ugyanitt
 *  látszanak a KÉRŐ irányú kapcsolatok is (amiket ez az intézmény más rendszerekhez kötött), és itt
 *  állítható be a rendszer neve és nyilvános címe a központi címjegyzékhez.
 */
@Component({
  selector: 'app-admin-kapcsolatok',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './kapcsolatok.component.html',
  styleUrls: ['./kapcsolatok.component.scss'],
})
export class AdminKapcsolatokComponent implements OnInit {
  adat: any = null;
  hiba = '';
  fut = false;
  kert: Record<string, boolean> = { ber: true, jelenlet: true, szamla: true, szamlazo: false, keszlet: false };
  cegId = '';
  ora = 0;   // 0 = visszavonásig érvényes (alapértelmezés); egyébként óra
  ujKod: any = null;
  inst = { nev: '', url: '' };

  constructor(private http: HttpClient, private data: DataService) {}

  //  A tárolt intézményből és alrendszerből (mint az admin-keret): közvetlen URL-betöltéskor az
  //  app-keret még nem regisztrált, és üres intézménnyel „nem admin" hibát kapnánk.
  intezmeny = '';
  private alrendszer = 'SULINFORM';
  private ut(vege = '') { return `/api/kapcsolat/admin/${this.intezmeny}${vege}`; }
  private opts() { return { params: { alrendszer: this.alrendszer } }; }

  async ngOnInit() {
    this.intezmeny = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId || '';
    this.alrendszer = String((await this.data.getFromStorage('currentMode')) || 'SULINFORM');
    await this.betolt();
  }

  async betolt() {
    this.hiba = '';
    try {
      this.adat = await firstValueFrom(this.http.get(this.ut(), this.opts()));
      this.inst = { nev: this.adat.installacio?.nev || '', url: this.adat.installacio?.url || '' };
    } catch (e: any) { this.adat = null; this.hiba = e?.error?.error || 'A kapcsolatok nem tölthetők be.'; }
  }

  hatokorLista(): string[] { return Object.keys(this.adat?.hatokorok || {}); }
  /** A Számla és Kassza / Készletkezelés adatköre egy cégé – ilyenkor a céget is ki kell választani. */
  get cegesKell() { return Object.keys(this.kert).some((h) => this.kert[h] && this.adat?.hatokorok?.[h]?.ceges); }
  cegNev(id: string) { return (this.adat?.cegek || []).find((c: any) => c.id === id)?.nev || ''; }
  hatokorNev(h: string) { return this.adat?.hatokorok?.[h]?.nev || h; }
  get kiadunk() { return (this.adat?.kapcsolatok || []).filter((k: any) => k.irany === 'ki'); }
  get kerunk() { return (this.adat?.kapcsolatok || []).filter((k: any) => k.irany === 'be'); }

  private async muvelet(f: () => Promise<any>) {
    this.fut = true; this.hiba = '';
    try { const r = await f(); await this.betolt(); return r; }
    catch (e: any) { this.hiba = e?.error?.error || 'A művelet nem sikerült.'; return null; }
    finally { this.fut = false; }
  }

  async kodKiad() {
    const hatokorok = Object.keys(this.kert).filter((h) => this.kert[h]);
    const r = await this.muvelet(() => firstValueFrom(this.http.post(this.ut('/kod'), { hatokorok, ora: this.ora, ugyfel_id: this.cegesKell ? this.cegId : null }, this.opts())));
    if (r) this.ujKod = r;
  }
  async masol(kod: string) { try { await navigator.clipboard.writeText(kod); } catch { /* a felhasználó kézzel másolja */ } }
  kodTorol(k: any) { return this.muvelet(() => firstValueFrom(this.http.delete(this.ut(`/kod/${k.id}`), this.opts()))); }
  async visszavon(k: any) {
    if (!confirm(`Biztosan megszünteted a kapcsolatot (${k.tars_nev || k.tars_intezmeny})? Utána csak új kóddal köthető össze újra.`)) return;
    await this.muvelet(() => firstValueFrom(this.http.post(this.ut(`/visszavon/${k.id}`), {}, this.opts())));
  }
  instMent() { return this.muvelet(() => firstValueFrom(this.http.put(this.ut('/installacio'), this.inst, this.opts()))); }
  cimjegyzek() { return this.muvelet(() => firstValueFrom(this.http.post(this.ut('/cimjegyzek'), {}, this.opts()))); }
}
